var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.item.is_available)?_c('a',{class:_vm.buttonClass,attrs:{"title":_vm.item.wishlist ? 'Remove from wishlist' : 'Add to wishlist'},on:{"click":function($event){return _vm.toggleState()}}},[_c('b-icon',{attrs:{"pack":"mdi","icon":"oil-lamp","size":"is-small"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }